export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

export const FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';
